export default __webpack_public_path__ + "static/media/13-3.36c7a6bd.jpg";